// Пул ссылок, при совпадении с которыми карточке проставляется флажок AREST-5657
// Решение добавлять их в глубину вьюшки спорное, но по крайней мере так они будут выделяться везде
// в т.ч. на новых страницах
// А конкретная ссылка - условие достаточно специфическое, чтобы особо ничего не бояться
export const CHEVRON_LINKS: Set<string> = new Set([
  '/spb/restaurants/luchshie-bary-sankt-peterburga-2025',
  '/spb/restaurants/luchshie-otkrytiya-2025-goda-v-peterburge',
  '/spb/restaurants/luchshie-restorany-sankt-peterburga-2025',
  '/spb/restaurants/vybor-pol-zovatelej-afishi-restorany-2025',
  '/msk/restaurants/luchshie-restorany-moskvy-2025',
  '/msk/restaurants/luchshie-otkrytiya-2025-goda',
  '/msk/restaurants/luchshie-bary-moskvy-2025',
  '/msk/restaurants/vybor-pol-zovatelej-afishi-restorany-2025',
])

export function isHardcodedChevronLink(link: string): boolean {
  const normalized = link.endsWith('/') ? link.slice(0, -1) : link
  return CHEVRON_LINKS.has(normalized)
}
